
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import VueTreeselect from "@riophae/vue-treeselect";
import api from "@/services/api.service";
import EventCategory from "@/types/sv-data/events/EventCategory";

@Component({
	components: {
		"vue-treeselect": VueTreeselect
	}
})
export default class EventOutcomeSingleSelect extends Vue {
	
	@Prop({ type: Number, default: null})
	public value: number;

	@Prop({ type: String, required: false, default: "Search"})
	private placeholder: string;

	@Prop({ type: Boolean, default: false })
	private readOnly: boolean;

	private eventCategoriesTree: EventCategory[] = [];
	private isLoading: boolean = true;
	private previousSelection: number | null = null;
	private newSelection: number | null = null;

	private async beforeMount(): Promise<void> {
		try {
			// Clear array to prevent invalid values being displayed, while awaiting API call.
			this.previousSelection = this.value;
			this.newSelection = null;
			this.eventCategoriesTree = await api.fetchEventOutcomeTree();

			// Reapply values after api call to be shown.
			this.newSelection = this.previousSelection;
		} catch(err) {
			console.error("Failed to retrieve EventOutomeCategories", err);
		} finally {
			this.isLoading = false;
		}
	}

	@Watch("value")
	private onValueChanged(): void {
		this.previousSelection = this.newSelection;
		this.newSelection = this.value;
	}

	private beforeDestroy(): void {
		this.eventCategoriesTree = [];
		this.newSelection = null;
		this.previousSelection = null;
	}

	private normalizer(e: any): any {
		// Case for hiding the database ID in case value has been deleted after being selected
		if (!e.hasOwnProperty("eventOutcomeID")) {
			e.id = null;
			e.label = "";
		} else {
			e.id = e.eventOutcomeID;
			e.label = e.title;
			e.children = e.childOutcomes;
		}			
		return e;
	}
	private onInputChanged(input: number | number[]): void {
		this.$emit("input", input);
	}
}
